<template>
  <div class="wrapper__content">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "EmptyLayout"
  }
</script>
